export default __webpack_public_path__ + "static/media/absorption.30df8f1f.svg";